import { useEffect, useState, forwardRef, ReactElement } from 'react';
import Modal from 'react-bootstrap/Modal';
import toast from 'react-hot-toast';
import api from '../components/api';
import TextInput from '../components/TextInput';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: ReactElement<any, any> },
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ModalNovoUsuario = (props: any) => {

    interface iPerfis {
        descricao: string;
        perfil_id: number;
    }

    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);

    const [cpf, setCpf] = useState('');
    const [nome, setNome] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmaSenha, setConfirmaSenha] = useState('');
    const [perfil_id, setPerfil_id] = useState<number | undefined>();
    const [ad_usr, setAd_usr] = useState<number | undefined>();
    const [perfis, setPerfis] = useState<React.JSX.Element[]>([]);

    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios');

    useEffect(() => {
        if (dadosUsuarios) {
            const dados = JSON.parse(dadosUsuarios);
            setAd_usr(dados.usuario_id ? Number(dados.usuario_id) : undefined);
        }
    }, [dadosUsuarios]);

    useEffect(() => {
        setShow(props.show);
        if (props.show) {
            setCpf('');
            setNome('');
            setSenha('');
            setConfirmaSenha('');
            setPerfil_id(undefined);
        }
    }, [props.show, props.now]);

    useEffect(() => {
        api.get('perfilListaTodos').then((result) => {
            setPerfis(result.data.map((rs: iPerfis) => (
                <option key={rs.perfil_id} value={rs.perfil_id}>{rs.descricao}</option>
            )));
        }).catch((err) => console.log(err.response));
    }, []);

    const validaSalvar = () => {
        const cpfLimpo = cpf.replace(/\D/g, '');

        if (cpfLimpo.length !== 11) {
            toast.error('CPF inválido!');
            return;
        }
        if (nome.trim() === '') {
            toast.error('Nome não pode ficar em branco!');
            return;
        }
        if (!perfil_id) {
            toast.error('Selecione o perfil!');
            return;
        }
        if (senha === '') {
            toast.error('Senha não pode ficar em branco!');
            return;
        }
        if (senha !== confirmaSenha) {
            toast.error('As senhas não conferem!');
            return;
        }

        setOpen(true);
    };

    const salvar = () => {
        const cpfLimpo = cpf.replace(/\D/g, '');

        const dataPost = {
            cliente_id: props.cliente_id,
            perfil_id,
            cpf: cpfLimpo,
            nome: nome.trim(),
            senha,
            ad_usr,
        };

        api.post('usuario', dataPost).then((result) => {
            if (result.data.status === 'ok') {
                toast.success('Usuário criado com sucesso!');
                props.setShow(false);
                props.carrega();
            } else {
                toast.error(result.data.descricao || 'Erro ao criar usuário.');
            }
            setOpen(false);
        }).catch((err) => {
            console.log(err.response);
            toast.error('Erro ao criar usuário.');
            setOpen(false);
        });
    };

    return (
        <div>
            <Modal
                size="lg"
                show={show}
                onHide={() => props.setShow(false)}
                aria-labelledby="modal-novo-usuario"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="modal-novo-usuario">
                        Novo Usuário
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">

                        <div className="col-md-4">
                            <label className="form-label">CPF *</label>
                            <TextInput
                                placeholder="000.000.000-00"
                                maskType="cpf"
                                value={cpf}
                                className="form-control"
                                onChange={(event: any) => setCpf(event.target.value)}
                            />
                        </div>
                        <div className="col-md-8">
                            <label className="form-label">Nome *</label>
                            <input
                                type="text"
                                className="form-control"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                maxLength={150}
                            />
                        </div>

                        <div className="col-md-4">
                            <label className="form-label">Perfil *</label>
                            <select
                                className="form-control"
                                value={perfil_id ?? ''}
                                onChange={(e) => setPerfil_id(e.target.value ? Number(e.target.value) : undefined)}
                            >
                                <option value="">[Selecione]</option>
                                {perfis}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Senha *</label>
                            <input
                                type="password"
                                className="form-control"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                maxLength={50}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Confirmar Senha *</label>
                            <input
                                type="password"
                                className="form-control"
                                value={confirmaSenha}
                                onChange={(e) => setConfirmaSenha(e.target.value)}
                                maxLength={50}
                            />
                        </div>

                        <div className="col-12" style={{ textAlign: 'right' }}>
                            <button type="button" className="btn btn-dark" onClick={() => props.setShow(false)}>
                                Fechar
                            </button>&nbsp;
                            <button type="button" className="btn btn-success" onClick={validaSalvar}>
                                Salvar
                            </button>
                        </div>

                    </div>
                </Modal.Body>
            </Modal>

            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">Confirmação</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ textAlign: 'justify' }}>
                        Deseja criar o usuário?
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button color="error" variant="contained" onClick={() => setOpen(false)}>
                        Cancelar
                    </Button>
                    <Button color="success" variant="contained" onClick={salvar}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ModalNovoUsuario;
